<template>
  <div>
    <input
      v-model="html"
      type="hidden"
      :name="name"
    >
    <tinymce
      v-model="html"
      :init="{
        hidden_input: false,
        menubar: false,
        name,
        placeholder,
        plugins: [
           'advlist autolink lists link image charmap print preview anchor',
           'searchreplace visualblocks code fullscreen',
           'insertdatetime media table paste code help wordcount'
         ],
         toolbar:
           `undo redo | bold italic |
           | link unlink |
           bullist numlist outdent indent | removeformat`
      }"
      :inline="true"
    ></tinymce>
  </div>
</template>

<script>
import Tinymce from '@tinymce/tinymce-vue'

export default {
  components: {
    Tinymce,
  },
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default () {
        return ''
      }
    },
    placeholder: {
      type: String,
      default () {
        return ''
      }
    }
  },
  data () {
    return {
      html: this.value
    }
  },
  watch: {
    html () {
      this.$emit('input', this.html)
    }
  }
}
</script>